import React from "react";
import { IconProps } from "./types";

function IconPin(props: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="pin 1" clipPath="url(#clip0_1094_45203)">
        <path
          id="Vector"
          d="M8 1.83331C6.59471 1.83324 5.24617 2.38782 4.2475 3.37651C3.24882 4.3652 2.68072 5.70809 2.66667 7.11331C2.66667 10.7666 7.36667 14.8333 7.56667 15.0066C7.68742 15.1099 7.8411 15.1667 8 15.1667C8.1589 15.1667 8.31258 15.1099 8.43333 15.0066C8.66667 14.8333 13.3333 10.7666 13.3333 7.11331C13.3193 5.70809 12.7512 4.3652 11.7525 3.37651C10.7538 2.38782 9.4053 1.83324 8 1.83331ZM8 13.6C6.88667 12.54 4 9.59998 4 7.11331C4 6.05245 4.42143 5.03503 5.17157 4.28489C5.92172 3.53474 6.93914 3.11331 8 3.11331C9.06087 3.11331 10.0783 3.53474 10.8284 4.28489C11.5786 5.03503 12 6.05245 12 7.11331C12 9.57998 9.11333 12.54 8 13.6Z"
          fill="#1E293B"
        />
        <path
          id="Vector_2"
          d="M8 4.5C7.53851 4.5 7.08738 4.63685 6.70367 4.89324C6.31995 5.14963 6.02088 5.51404 5.84428 5.94041C5.66768 6.36677 5.62147 6.83592 5.7115 7.28854C5.80153 7.74117 6.02376 8.15693 6.35008 8.48325C6.67641 8.80957 7.09217 9.0318 7.54479 9.12183C7.99741 9.21186 8.46657 9.16566 8.89293 8.98905C9.31929 8.81245 9.6837 8.51338 9.94009 8.12966C10.1965 7.74595 10.3333 7.29482 10.3333 6.83333C10.3333 6.21449 10.0875 5.621 9.64991 5.18342C9.21233 4.74583 8.61884 4.5 8 4.5ZM8 7.83333C7.80222 7.83333 7.60888 7.77468 7.44443 7.6648C7.27998 7.55492 7.15181 7.39874 7.07612 7.21602C7.00043 7.03329 6.98063 6.83222 7.01921 6.63824C7.0578 6.44426 7.15304 6.26608 7.29289 6.12623C7.43274 5.98637 7.61093 5.89113 7.80491 5.85255C7.99889 5.81396 8.19996 5.83377 8.38268 5.90945C8.56541 5.98514 8.72159 6.11331 8.83147 6.27776C8.94135 6.44221 9 6.63555 9 6.83333C9 7.09855 8.89464 7.3529 8.70711 7.54044C8.51957 7.72798 8.26522 7.83333 8 7.83333Z"
          fill="#1E293B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1094_45203">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconPin;
